/**
 * Quantity input for the BuyStack14 component
 */
export default class QuantityInput extends HTMLElement {
  /**
   * The id of the product variant associated with the quantity input
   */
  public variantId: number;

  private _value = 0;

  constructor() {
    super();
    this.variantId = Number(this.getAttribute('variant-id'));
  }

  /**
   * The current quantity value
   */
  public get value() {
    return this._value;
  }

  public set value(newValue: number) {
    this._value = newValue;
    this.render();
  }

  public connectedCallback() {
    this.initState();
    this.setupListeners();
  }

  private initState() {
    this._value = Number(this.getAttribute('value')) || 0;
  }

  private setupListeners() {
    this.onclick = (e) => this.handleClick(e);
  }

  private handleClick({target}: MouseEvent) {
    if (target instanceof HTMLElement) {
      switch (target.dataset.action) {
        case 'increment':
          this.handleIncrement();
          break;
        case 'decrement':
          this.handleDecrement();
          break;
      }
    }
  }

  private handleIncrement() {
    this.value++;

    const event = this.createEvent('increment');
    this.dispatchEvent(event);
  }

  private handleDecrement() {
    this.value--;
    const event = this.createEvent('decrement');
    this.dispatchEvent(event);
  }

  private createEvent(name: string) {
    return new CustomEvent(name, {
      detail: {
        variantId: this.variantId,
      },
      bubbles: true,
    });
  }

  private render(): void {
    const output = this.querySelector('output');
    const value = String(this.value);

    output?.replaceChildren(value);
    this.setAttribute('value', value);
  }
}

if (!customElements.get('quantity-input')) {
  customElements.define('quantity-input', QuantityInput);
}
